<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item :label="item.GroupName" v-for="item in tageSelect" :key="item.GroupName">
        <el-select v-model="form[item.GroupName]" placeholder="请选择活动区域" multiple>
          <el-option
            :label="it.LabelName"
            :value="it.Id"
            v-for="it in item.LabelList"
            :key="it.Id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="addButton">添加分类标签</div>
  </div>
</template>

<script>
import { GetAllLabelInfoList } from '@/api/releaseManagement.js';
export default {
  data() {
    return {
      form: {},
      tagsList: [], // 全量标签
      tageSelect: [], // 选中的标签
    };
  },
  created() {
    GetAllLabelInfoList().then((res) => {
      this.tagsList = res.LabelGroupList;
      this.tageSelect = this.tagsList.slice(0, 2);
    });
  },
};
</script>

<style scoped>
.addButton {
  color: aqua;
}
</style>
